import "./style.less";
import "script-loader!./mobiscroll/js/mobiscroll.dom";
import "script-loader!./mobiscroll/js/mobiscroll.core";
import "script-loader!./mobiscroll/js/mobiscroll.scrollview";
import "script-loader!./mobiscroll/js/mobiscroll.frame";
import "script-loader!./mobiscroll/js/mobiscroll.scroller";
import "script-loader!./mobiscroll/js/mobiscroll.android-holo-light";
import "script-loader!./mobiscroll/js/i18n/mobiscroll.i18n.da";

import "./mobiscroll/css/mobiscroll.animation.css";
import "./mobiscroll/css/mobiscroll.frame.css";
import "./mobiscroll/css/mobiscroll.scroller.css";
import "./mobiscroll/css/mobiscroll.scroller.android-holo.css";
import "./mobiscroll/css/mobiscroll.android-holo-light.css";

import SearchBarTime from "./directive";
import SearchBarTimeDropdown from "./dropdown/";
import numberSelector from "./dropdown/number-selector";

import timeFactory from "./timeFactory";

const modul = angular
    .module("searchBarTime", [])
    .directive("searchBarTime", SearchBarTime)

    .directive("searchBarTimeDropdown", SearchBarTimeDropdown)
    .directive("numberSelector", numberSelector)

    .factory("timeFactory", timeFactory);

export default modul.name;
